import styled from 'styled-components';

const Image = styled.img`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  object-fit: ${(props) => props.$objectfit};
  border-radius: 50%;
`;

Image.defaultProps = {
  width: '50px',
  height: '50px',
  objectfit: 'cover',
};

export default Image;
